import { ContentTypeModuleHeading } from "../../contentTypes/ContentTypeModuleHeading/ContentTypeModuleHeading";
import { ISiteModuleImageGallery } from "../../interfaces/ISiteModule";
import { ISiteV2 } from "../../interfaces/Site";
import { SiteModuleImageGalleryItem } from "./SiteModuleImageGalleryItem/SiteModuleImageGalleryItem";
import styles from "./SiteModuleImageGallery.module.scss";
import { ContentTypeRichText } from "../../contentTypes/ContentTypeRichText/ContentTypeRichText";
import { useTranslation } from "../../../contexts/LanguageContext";
import { rteContentIsEmpty } from "../../utils/rteContentIsEmpty";

interface IProps {
    site: ISiteV2;
    siteModule: ISiteModuleImageGallery;
}

export const SiteModuleImageGallery = (props: IProps) => {
    const { getInTranslation } = useTranslation();
    
    const showTextBox =
        !rteContentIsEmpty(getInTranslation(props.siteModule.text.richText));

    return (
        <section className={styles[props.site.theme]}>
            <ContentTypeModuleHeading contentData={props.siteModule.title} site={props.site} />
            {showTextBox ? (
                <div className={styles.rteWrapper}>
                    <ContentTypeRichText contentData={props.siteModule.text} site={props.site} />
                </div>
            ) : null}
            {props.siteModule.gallery.length ? (
                <div className={styles.itemsWrapper}>
                    {props.siteModule.gallery.map((listItem) => (
                        <SiteModuleImageGalleryItem
                            site={props.site}
                            listItem={listItem}
                            key={listItem.id}
                            gallery={props.siteModule.gallery}
                        />
                    ))}
                </div>
            ) : null}
        </section>
    );
};
